
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import { catalogPageParams } from "../../../common/catalog/catalogPageSize";
import Paginator from "../../../common/paginator/Paginator";
import Discussion from "./Discussion";


export default function DiscussionSection({ isDesktop, query }) {
	const [discussions, setDiscussions] = useState([]);
	const [page, setPage] = useState(1);
	const [maxPageNum, setMaxPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchDiscussions(1);
	}, []);

	useEffect(() => {
		if (page !== 1) {
			setPage(1);
		}
		fetchDiscussions(1);
	}, [query]);

	useEffect(() => {
		fetchDiscussions(page);
	}, [page]);

	function fetchDiscussions(currentPage) {
		if (isLoading) {
			return;
		}
		setIsLoading(true);
		let queryParam = query ? query : '';
		api.discussionSearch({
			query: queryParam,
			...catalogPageParams(currentPage),
		}).then((result) => {
			setDiscussions(result['discussions']);
			setMaxPageNum(result['max_page']);
			setIsLoading(false);
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	return (
		<div>
			<div className={`grid gap-[20px] ${isDesktop ? 'grid-cols-4' : 'grid-cols-1'}`}>
				{discussions.map(discussion => (
					<Discussion key={discussion.id} discussion={discussion} />
				))}
			</div>
			{discussions.length >= 1 && maxPageNum >= 2 && (
				<>
					<div className="spacer p-[20px]"></div>
					<div className="flex flex-row justify-center">
						<Paginator currentPage={page} maxPageNum={maxPageNum} isLoading={isLoading} onChange={(newPage) => { setPage(newPage) }} />
					</div>
				</>
			)}
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</div>
	)
}
